// 20250719: xt/chtg converted the react-bootstrap to only bootstrap 5.3.3 
//         this way we can remove/uninstall react-bootstrap completely
import React from 'react'
import { connect } from 'react-redux'
import { hideModal, showModal, updateModalProps } from '../../actions/modal'
//import { Modal, ListGroup, ListGroupItem, FormGroup, FormControl, InputGroup } from 'react-bootstrap'

const SelectShiftModal = ({
  agency,
  incident,
  unitId,
  reportSchemaId,
  shifts,
  dispatch,
  visible,
  languageCode
}) => {
  const shiftsMaster = agency.assignees.shifts
  const hide = () => dispatch(hideModal())
  const saveSelection = (assignmentId) => {
    dispatch(hideModal())

    if (agency.assignees.roles) {
      const roleModalProps = {
        agency,
        incident,
        unitId,
        shiftId: assignmentId,
        reportSchemaId: incident.report_schema_id,
        assignedRole: incident.role_id,
        roles: agency.assignees.roles,
        languageCode
      }

      dispatch(showModal('SELECT_ROLE', roleModalProps))
    } else {
      const startDateModalProps = {
        agency,
        incident,
        unitId,
        shiftId: assignmentId,
        reportSchemaId: incident.report_schema_id,
        assignedRole: incident.role_id,
        roleId: null,
        languageCode
      }

      dispatch(showModal('SELECT_START_DATE', startDateModalProps))
    }
  }

  const filterList = (event) => {
    var updatedList = shiftsMaster
    updatedList = updatedList.filter((item) => {
      return item.name[languageCode].toLowerCase().search(
        event.target.value.toLowerCase()) !== -1
    })

    dispatch(updateModalProps('shifts', updatedList))
  }

  // return (
  //   <Modal show={visible} onHide={hide} id='shift-modal' dialogClassName='assignment-modal' backdrop>
  //     <Modal.Header closeButton closeLabel='Cancel'>
  //       <Modal.Title>Select Shift</Modal.Title>
  //     </Modal.Header>
  //     <Modal.Body>

  //       <FormGroup>
  //         <InputGroup id='department-search-input'>
  //           <InputGroup>
  //             <FormControl placeholder="Search" />
  //               <InputGroup.Text>
  //                 <span className="material-icons">search</span>
  //                 </InputGroup.Text>
  //                 </InputGroup>
  //             <FormControl id='department-search' type='text' placeholder='Search' onChange={filterList} />
  //           </InputGroup>
  //       </FormGroup>

  //       <ListGroup className='text-medium'>
  //         {shifts.map(shift =>
  //           <ListGroupItem key={shift._id} onClick={() => saveSelection(shift._id)}>
  //             <div className='shift-name'>{shift.name[languageCode]}</div>
  //           </ListGroupItem>
  //         )}
  //       </ListGroup>
  //     </Modal.Body>
  //   </Modal>
  // )

  return (
  visible && (
    <>
      <div
        className="modal fade show d-block"
        id="shift-modal"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-dialog assignment-modal" role="document">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">Select Shift</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Cancel"
                onClick={hide}
              ></button>
            </div>

            <div className="modal-body">

              <div className="mb-3">
                <div id="department-search-input" className="input-group mb-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                  />
                  <span className="input-group-text">
                    <span className="material-icons">search</span>
                  </span>
                </div>

                <input
                  id="department-search"
                  type="text"
                  className="form-control"
                  placeholder="Search"
                  onChange={filterList}
                />
              </div>

              <ul className="list-group text-medium">
                {shifts.map((shift) => (
                  <li
                    key={shift._id}
                    className="list-group-item"
                    style={{ cursor: "pointer" }}
                    onClick={() => saveSelection(shift._id)}
                  >
                    <div className="shift-name">{shift.name[languageCode]}</div>
                  </li>
                ))}
              </ul>

            </div>
          </div>
        </div>
      </div>

      <div className="modal-backdrop fade show"></div>
    </>
  )
);

}

export default connect()(SelectShiftModal)
